/** @format */

import { markRaw } from 'vue';
import { Delete } from '@element-plus/icons-vue';
import { ElMessage, ElMessageBox, ElNotification, ElLoading, ElMessageBoxOptions } from 'element-plus';

let loadingInstance;

export const PcModal = {
	// 消息提示
	msg(content) {
		ElMessage.info(content);
	},
	// 错误消息
	msgError(content) {
		ElMessage.error(content);
	},
	// 成功消息
	msgSuccess(content) {
		ElMessage.success(content);
	},
	// 警告消息
	msgWarning(content) {
		ElMessage.warning(content);
	},
	// 弹出提示
	alert(content) {
		ElMessageBox.alert(content, '系统提示');
	},
	// 错误提示
	alertError(content) {
		ElMessageBox.alert(content, '系统提示', { type: 'error' });
	},
	// 成功提示
	alertSuccess(content) {
		ElMessageBox.alert(content, '系统提示', { type: 'success' });
	},
	// 警告提示
	alertWarning(content) {
		ElMessageBox.alert(content, '系统提示', { type: 'warning' });
	},
	// 通知提示
	notify(content) {
		ElNotification.info(content);
	},
	// 错误通知
	notifyError(content) {
		ElNotification.error(content);
	},
	// 成功通知
	notifySuccess(content) {
		ElNotification.success(content);
	},
	// 警告通知
	notifyWarning(content) {
		ElNotification.warning(content);
	},
	//确认
	verify(text1) {
		console.log('确认');
		ElMessage({
			type: 'success',
			message: text1,
		});
	},
	//取消
	verify2(text2, cancelButtonText) {
		console.log('执行取消');
		if (cancelButtonText) {
			ElMessageBox.confirm('确定要取消吗？', 'info', {
				confirmButtonText: '确定',
				cancelButtonText: '取消',
				type: 'warning',
			})
				.then(() => {
					ElMessage({
						type: 'info',
						message: text2,
					});
				})
				.catch(() => {
					console.log('取消');
				});
		}
	},
	// 确认窗体
	confirm(content, text1, text2, confirmButtonText, cancelButtonText) {
		return ElMessageBox.confirm(
			content,
			'系统提示',

			{
				dangerouslyUseHTMLString: true,
				confirmButtonText,
				cancelButtonText,
				type: 'warning',
			},
		)
			.then((action) => {
				if (action === 'confirm') {
					this.verify(text1);
				}
			})
			.catch(() => {
				this.verify2(text2, cancelButtonText);
			});
	},
	//业务逻辑提示

	businessLogic(text, text1, text2, confirmButtonText, cancelButtonText) {
		ElMessageBox.confirm(
			text.includes('永久删除')
				? `${text.split('永久删除')[0]}<strong> <span style="color:red">永久删除</span></strong> ${
						text.split('永久删除')[1]
				  }`
				: text,
			'提示',

			{
				dangerouslyUseHTMLString: true,
				confirmButtonText,
				cancelButtonText,
				type: 'warning',
				icon: markRaw(Delete),
			},
		)
			.then((action) => {
				if (action === 'confirm') {
					this.verify(text1);
				}
			})
			.catch(() => {
				this.verify2(text2, cancelButtonText);
			});
	},
	// 提交内容
	prompt(content) {
		return ElMessageBox.prompt(content, '系统提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		});
	},
	// 打开遮罩层
	loading(content) {
		loadingInstance = ElLoading.service({
			lock: true,
			text: content,
			background: 'rgba(0, 0, 0, 0.7)',
		});
	},
	// 关闭遮罩层
	closeLoading() {
		loadingInstance.close();
	},

	PcMessageBox: ({
		title = '系统提示',
		type = 'warning',
		message,
		...msgProp
	}: ElMessageBoxOptions): Promise<{ action: string; done: () => void }> => {
		return new Promise((resolve, reject) => {
			ElMessageBox({
				type,
				title,
				message,
				showCancelButton: true,
				confirmButtonText: '确认',
				cancelButtonText: '取消',
				cancelButtonClass: 'is-plain',
				...msgProp,
				beforeClose: (action, instance, done) => {
					if (action === 'confirm') {
						instance.confirmButtonLoading = true;
						resolve({ action, done });
					} else {
						instance.cancelButtonLoading = true;
						reject({ action, done });
					}
				},
			});
		});
	},
	// 确认窗体
	msgConfirm(content) {
		return ElMessageBox.confirm(content, '系统提示', {
			confirmButtonText: '确定',
			cancelButtonText: '取消',
			type: 'warning',
		});
	},
};
